import apiClient from "../config/api";
import { getUserId, getWorkshopId } from "../config/constants";

const resolveContext = (workshopId) => {
  const userId = getUserId();
  const effectiveWorkshopId = workshopId || getWorkshopId();

  if (!userId) throw new Error("Usuario no identificado");
  if (!effectiveWorkshopId) throw new Error("Taller no seleccionado");

  return { userId, workshopId: effectiveWorkshopId };
};

export const orderService = {
  async getOrders({
    page = 1,
    range = 30,
    offset = 0,
    status = "",
    workshopId,
  } = {}) {
    const ctx = resolveContext(workshopId);
    const params = new URLSearchParams({
      page: String(page),
      range: String(range),
      offset: String(offset),
    });
    if (status) params.append("filter", status);

    const response = await apiClient.get(
      `/${ctx.workshopId}/orders?${params.toString()}`,
    );
    return response.data;
  },

  async getFilteredOrders({ filtersQuery = "", workshopId } = {}) {
    const ctx = resolveContext(workshopId);
    const url = `/${ctx.workshopId}/orders${filtersQuery ? `?${filtersQuery}` : ""}`;
    const response = await apiClient.get(url);
    return response.data;
  },

  async getOrderDetails(orderId, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.get(
      `/${ctx.workshopId}/order/details/${orderId}`,
    );
    return response.data;
  },

  async getCustomers(workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.get(
      `/${ctx.workshopId}/customers`,
    );
    return response.data;
  },

  async getSuppliers(workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.get(
      `/${ctx.workshopId}/suppliers`,
    );
    return response.data;
  },

  async getCustomerById(customerId, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.get(
      `/${ctx.workshopId}/customer/${customerId}`,
    );
    return response.data;
  },

  async getCarById(carId, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.get(
      `/${ctx.workshopId}/car/${carId}`,
    );
    return response.data;
  },

  async createOrder(payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.post(
      `/${ctx.workshopId}/order`,
      payload,
    );
    return response.data;
  },

  async updateOrder(orderId, payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/order/${orderId}`,
      payload,
    );
    return response.data;
  },

  async deleteOrder(orderId, isDeleted, workshopId) {
    const ctx = resolveContext(workshopId);

    if (!workshopId) {
      throw new Error('Taller no seleccionado');
    }
    const response = await apiClient.put(
      `/${ctx.workshopId}/order/${orderId}`,
      { data: isDeleted },
    );
    return response.data;
  },

  async updateOrderProcessState(orderId, payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/order/${orderId}/process-state`,
      payload,
    );
    return response.data;
  },

  async createRepair(payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.post(
      `/${ctx.workshopId}/repair`,
      payload,
    );
    return response.data;
  },

  async updateRepair(repairId, payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/repair/${repairId}`,
      payload,
    );
    return response.data;
  },

  async deleteRepair(repairId, isDeleted, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/repair/${repairId}`,
      { data: isDeleted },
    );
    return response.data;
  },

  async createRepairItem(payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.post(
      `/${ctx.workshopId}/repair-item`,
      payload,
    );
    return response.data;
  },

  async updateRepairItem(itemId, payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/repair-item/${itemId}`,
      payload,
    );
    return response.data;
  },

  async deleteRepairItem(itemId, isDeleted, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/repair-item/${itemId}`,
      { data: isDeleted },
    );
    return response.data;
  },

  async reassignCarClient(carId, payload, workshopId) {
    const ctx = resolveContext(workshopId);
    const response = await apiClient.put(
      `/${ctx.workshopId}/car/${carId}`,
      payload,
    );
    return response.data;
  },
};
